import { toast } from "react-toastify";

const activeToasts = new Map();

const stringifyMessage = (message) => {
  if (typeof message === "string") {
    return message;
  }

  if (message === undefined || message === null) {
    return String(message);
  }

  if (typeof message === "object") {
    try {
      return JSON.stringify(message);
    } catch (error) {
      return String(message);
    }
  }

  return String(message);
};

const getKey = (type, message, options = {}) => {
  if (options && options.toastId !== undefined && options.toastId !== null) {
    return options.toastId;
  }

  return `${type}:${stringifyMessage(message)}`;
};

const showToast = (type, message, options = {}) => {
  const key = getKey(type, message, options);
  const existingId = activeToasts.get(key);

  if (existingId && toast.isActive(existingId)) {
    return existingId;
  }

  const { onClose, ...restOptions } = options;
  const toastFn = typeof toast[type] === "function" ? toast[type] : toast;

  const toastId = toastFn(message, {
    ...restOptions,
    onClose: (...args) => {
      activeToasts.delete(key);

      if (typeof onClose === "function") {
        onClose(...args);
      }
    },
  });

  if (toastId !== undefined && toastId !== null) {
    activeToasts.set(key, toastId);
  }

  return toastId;
};

const safeToast = {
  success: (message, options) => showToast("success", message, options),
  error: (message, options) => showToast("error", message, options),
  warn: (message, options) => showToast("warn", message, options),
  info: (message, options) => showToast("info", message, options),
};

export default safeToast;

